export default "__VITE_ASSET__fr_L00p6__"